export default __webpack_public_path__ + "6e10cffa4e7d081abb94932a27d635ff.png";